export default function trimObjectProps(object) {
  for (const property in object) {
    if (typeof object[property] === "string" && property !== "password") {
      object[property] = object[property].trim();
    }
  }
}
